import { LTInput } from '@/components/design-system/molecules/form/LTInput'
import { LTTextarea } from '@/components/design-system/molecules/form/LTTextarea'

export const LTMoleculesForm = {
  Input: LTInput,
  Textarea: LTTextarea
}
